import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { TextButton } from 'seagull';
import { openInNewTabProps } from '~/constants';
export default function ExternalLinkButton(props) {
    const { href, openInNewTab, testId, children } = props, rest = _object_without_properties(props, [
        "href",
        "openInNewTab",
        "testId",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, rest, openInNewTab ? openInNewTabProps : {}), {
        as: "a",
        href: href,
        testId: testId,
        children: children
    }));
}
